import React, {FC} from 'react';
import {FormNameEnum} from 'filters-selections';
import {DatePickerSelection} from '../DatePickerSelection/DatePickerSelection';
import {IWithDisabled} from 'models/common';

interface IToDatePickerProps extends IWithDisabled {
  disableFuture?: boolean;
}

export const ToDatePicker: FC<IToDatePickerProps> = ({disabled, disableFuture = true}) => (
  <DatePickerSelection
    label="To"
    name={FormNameEnum.to}
    disableFuture={disableFuture}
    disabled={disabled}
    maxDateMessage="The selected date should be in the past"
  />
);
